<template>
    <card v-if="session">

        <!-- The file must be terminated -->
        <call-for-action :vertical="!compact"
            :reduce-text="false"
            :reduce-button="false"
            :action="$t('sessions.close-file')"
            :handler="closeFile"
            :disabled="!canCloseFile"
            v-if="mustTerminateFile"
        >
            <!-- Simulation -->
            <!--
            <div class="mb-4" v-if="mustTerminateSession">
                <i class="fas fa-exclamation-triangle text-warning"></i>
                <small class="text-uppercase font-weight-bold text-warning">
                    {{ $t('common.simulation') }}
                </small>
                <small class="d-block">
                    {{ $t('sessions.must-terminate-my-session') }}
                </small>
            </div>
            -->

            <!-- Send issues -->
            <div class="mb-4 clickable" v-if="mustSendIssues" @click="$emit('openIssues')">
                <i class="fas fa-exclamation-triangle text-danger"></i>
                <small class="text-uppercase font-weight-bold text-danger">
                    {{ $t('common.issues') }}
                </small>
                <small class="d-block">
                    {{ $t('sessions.must-send-issues') }}
                </small>
            </div>

            <!-- Issues sent -->
            <div class="mb-4 clickable" v-if="session.issued_at" @click="$emit('openIssues')">
                <i class="fas fa-check-circle text-success"></i>
                <small class="text-uppercase font-weight-bold text-success">
                    {{ $t('common.issues') }}
                </small>
                <small class="d-block">
                    {{ $t('sessions.issues-sent') }}
                </small>
            </div>

            <!-- Close learners files -->
            <div class="mb-4" v-if="mustCloseLearners">
                <i class="fas fa-exclamation-triangle text-danger"></i>
                <small class="text-uppercase font-weight-bold text-danger">
                    {{ $t('dashboard.learners-files') }}
                </small>
                <small class="d-block">
                    {{ $t('sessions.must-close-learners-files') }}
                </small>
            </div>

            <!-- Learners files closed -->
            <div class="mb-4" v-if="!mustCloseLearners">
                <i class="fas fa-check-circle text-success"></i>
                <small class="text-uppercase font-weight-bold text-success">
                    {{ $t('dashboard.learners-files') }}
                </small>
                <small class="d-block">
                    {{ $t('sessions.learners-files-closed') }}
                </small>
            </div>
            
        </call-for-action>

        <!-- Reopen the file -->
        <call-for-action :vertical="!compact"
            :action="$t('dashboard.reopen-file')"
            :handler="reopenFile"
            v-if="canReopenFile"
        >
            {{ $t('sessions.reopen-file-notice') }}
        </call-for-action>

        <portal to="modals">

            <confirm-modal v-model="modals.confirmClose">
                <p>{{ $t('sessions.close-file-confirm') }}</p>
            </confirm-modal>

            <confirm-modal v-model="modals.confirmReopen">
                <p>{{ $t('sessions.reopen-file-confirm') }}</p>
            </confirm-modal>

        </portal>
    </card>
</template>

<script>
    import CallForAction from '../../dashboard/common/CallForAction'
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        components: {
            CallForAction
        },

        model: {
            prop: 'session',
            event: 'change'
        },

        props: {

            session: {
                type: Object,
                required: true
            },

            mustSendIssues: {
                type: [Boolean, Number],
                default: false
            },

            compact: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                modals: new ModalsController(['confirmClose', 'confirmReopen'])
            }
        },

        created() {
            this.modals.init(this, 'modals')
        },

        computed: {

            learners() {
                let learners = []
                if (this.session.learner1) {
                    learners.push(this.session.learner1)
                }
                if (this.session.learner2) {
                    learners.push(this.session.learner2)
                }
                return learners
            },

            mustCloseLearners() {
                for (let index in this.learners) {
                    let learner = this.learners[index]
                    if (!learner.state.published) {
                        return true
                    }
                }
                return false
            },

            mustTerminateSession() {
                return !this.session.ended_at
            },

            mustTerminateFile() {
                return !this.session.closed_at
            },

            canCloseFile() {
                return !this.mustCloseLearners
                    && !this.mustSendIssues
            },

            canReopenFile() {
                return this.session.closed_at
            },
        },

        methods: {

            closeFile() {
                this.modals.open('confirmClose').then(resp => {
                    if (resp.confirmed) {
                        this.$loader.show()
                        axios.post('/astral/api/front/dashboard/sessions/'+this.session.id+'/close')
                        .then(resp => {
                            this.$loader.hide()
                            this.$emit('change', resp.data.data)
                        })
                        .catch(err => {
                            this.$auth.handleErrorVm(err, this)
                        })        
                    }
                })
            },
            
            reopenFile() {
                this.modals.open('confirmReopen').then(resp => {
                    if (resp.confirmed) {
                        this.$loader.show()
                        axios.post('/astral/api/front/dashboard/sessions/'+this.session.id+'/reopen')
                        .then(resp => {
                            this.$loader.hide()
                            this.$emit('change', resp.data.data)
                        })
                        .catch(err => {
                            this.$auth.handleErrorVm(err, this)
                        })        
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .clickable {
        cursor: pointer;
    }

</style>
